import { Component, OnDestroy, OnInit, AfterViewInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import swal from 'sweetalert2';
import { IssueService } from '../../services/issue.service';
import { getParamFromAncestorRoute, getQueryParamFromAncestorRoute } from '../../utilities/route.utilities';
import { PaygPaymentTypeModel } from '../../models/payg/payg-payment-type.model';
import { PaygService } from '../../services/payg.service';


@Component({
    selector: 'payment-by-type-item',
    templateUrl: './payment-by-type-item.component.html'
})
export class PaymentByTypeItemComponent implements AfterViewInit, OnDestroy {

    subscriptions: any[] = [];
    clientId: number;
    siteId: number;
    hasData: boolean = false;
    hasLoading: boolean = true;

    paymentByType: PaygPaymentTypeModel[] = [];

    constructor(
        private paygService: PaygService,
        private router: Router,
        private route: ActivatedRoute
    ) {
    }

    ngAfterViewInit(): void {
        this.subscriptions.push(this.route.queryParams.subscribe(queryParams => {
            this.onInitialise();
        }));
    }

    onInitialise() {
        this.paymentByType = [];
        this.clientId = getParamFromAncestorRoute(this.route, 'clientId');
        this.siteId = getQueryParamFromAncestorRoute(this.route, 'siteId');

    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    onInfoClick() {
        swal({
            title: 'Top-up choices',
            html: '<p style="text-align: left;">This chart is showing you all payments (top-ups) made by consumers in you PAYG portfolio.</p>\
              <p style="text-align: left;">Shown in value of all payments in each Month & Year as per the number of full months in the page filter and current month to date, by payment method type.</p>',
            confirmButtonText: 'Close',
            confirmButtonColor: '#00539f'
        });
    }
}
